import { render, staticRenderFns } from "./SuppliesCategoryEditComponent.vue?vue&type=template&id=403ce871"
import script from "./SuppliesCategoryEditComponent.vue?vue&type=script&lang=js"
export * from "./SuppliesCategoryEditComponent.vue?vue&type=script&lang=js"
import style0 from "./SuppliesCategoryEditComponent.vue?vue&type=style&index=0&id=403ce871&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports